var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formInputWithButton"},[_c('div',{staticClass:"formInputWithButton__input"},[_c('form-field',{attrs:{"value":_vm.value,"name":_vm.name,"type":"text","placeholder":_vm.placeholder,"is-tall":""},on:{"input":_vm.onInput}}),_vm._v(" "),_c('v-button',{class:[
        'formInputWithButton__button',
        { 'formInputWithButton__button--smallPadding': _vm.smallPadding },
      ],attrs:{"theme":_vm.theme,"text":_vm.isMobile && _vm.mobileText ? _vm.mobileText : _vm.text},on:{"click":_vm.onClick}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }